import { IconProps } from '@/components/Icons/types/IconInterface';
import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';

const PersonAddIcon = ({ size, variant, className }: IconProps) => {
  return (
    <svg
      className={cn(iconVariant({ variant, size, className }))}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="24.5" fill="#11E8C2" stroke="#11E8C2" />
      <path
        d="M18.25 19.375C18.25 17.0968 20.0968 15.25 22.375 15.25C24.6532 15.25 26.5 17.0968 26.5 19.375C26.5 21.6532 24.6532 23.5 22.375 23.5C20.0968 23.5 18.25 21.6532 18.25 19.375Z"
        fill="#010F55"
      />
      <path
        d="M15.25 32.125C15.25 28.19 18.44 25 22.375 25C26.31 25 29.5 28.19 29.5 32.125V32.1276C29.5 32.1674 29.4996 32.2074 29.499 32.2469C29.4946 32.5054 29.3574 32.7435 29.1359 32.8768C27.1607 34.0661 24.8466 34.75 22.375 34.75C19.9034 34.75 17.5893 34.0661 15.6141 32.8768C15.3926 32.7435 15.2554 32.5054 15.251 32.2469C15.2503 32.2064 15.25 32.1657 15.25 32.125Z"
        fill="#010F55"
      />
      <path
        d="M31.75 20.5C31.75 20.0858 31.4142 19.75 31 19.75C30.5858 19.75 30.25 20.0858 30.25 20.5V22.75H28C27.5858 22.75 27.25 23.0858 27.25 23.5C27.25 23.9142 27.5858 24.25 28 24.25H30.25V26.5C30.25 26.9142 30.5858 27.25 31 27.25C31.4142 27.25 31.75 26.9142 31.75 26.5V24.25H34C34.4142 24.25 34.75 23.9142 34.75 23.5C34.75 23.0858 34.4142 22.75 34 22.75H31.75V20.5Z"
        fill="#010F55"
      />
    </svg>
  );
};

export default PersonAddIcon;
